import React, { useContext, useEffect, useState } from "react";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import Image from "../../Components/Reusable/Image";
import { ConfirmationModalTheme, ImageFilters } from "../../Utils/Enums";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";
import { handleApiErrors, InputType } from "../../Utils/Utils";
import ConfirmationModal from "../../Components/modal/ConfirmationModal";
import { toast } from "react-toastify";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import { Link, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import DatePicker from "react-datepicker";
import Calanderimg from "../../assets/images/png/fi_12671954.png";
import CustomDropDown from "../../Components/Reusable/CustomDropDown";
import DataProvider from "../../Utils/DataProvider";
import { AuthContext } from "../../Context/authContext";
import ClassService from "../../Services/ClassService";
import SubjectService from "../../Services/SubjectService";
import ReviewerService from "../../Services/ReviewerService";
import parse from "html-react-parser";
import { FaCheck } from "react-icons/fa6";

const ReviewerHistory = () => {
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState(null);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [deleteId, setDeleteId] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const { user } = useContext(AuthContext);
  const [classes, setClasses] = useState([]);
  const [selectedClassFilter, setSelectedClassFilter] = useState("");
  const [selectedSubjectFilter, setSelectedSubjectFilter] = useState("");
  const [selectedStatusFilter, setSelectedStatusFilter] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);
  const [details, setDetails] = useState(null);
  const [selectedMedium, setSelectedMedium] = useState(null);
  const [subjects, setSubjects] = useState([]);
  const [mediumList, setMediumList] = useState(DataProvider.mediumList);
  const [statuslist, setStatuslist] = useState(DataProvider.Status);
  const [resetSubject, setResetSubject] = useState(false);
  const [resetmedium, setResetMedium] = useState(false);
  const [resetstatus, setResetStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleStartDateChange = (date) => setStartDate(date);
  const handleEndDateChange = (date) => setEndDate(date);

  const CustomDateInput = ({ value, onClick }) => (
    <div className="custom-date-input" onClick={onClick}>
      <input
        type="text"
        placeholder="From"
        value={value}
        readOnly
        className="form-control"
      />
      <img src={Calanderimg} alt="" className="calendar-icon" />
    </div>
  );
  const CustomDateInputTo = ({ value, onClick }) => (
    <div className="custom-date-input" onClick={onClick}>
      <input
        type="text"
        placeholder="To"
        value={value}
        readOnly
        className="form-control"
      />
      <img src={Calanderimg} alt="" className="calendar-icon" />
    </div>
  );

  const fetchData = async () => {
    try {
      const response = await ReviewerService.getreviewerhistorylist(
        limit,
        offset,
        searchQuery || "",
        selectedClassFilter?.value || "",
        selectedMedium || "",
        selectedSubjectFilter?.value || "",
        selectedStatusFilter || "",
        startDate,
        endDate
      );
      setData(response.data);
      setAvailableDataCount(response.availableDataCount);
      if (offset != 0 && offset * limit > availableDataCount - 1) {
        setOffset(offset - 1);
      }
    } catch (error) {
      handleApiErrors(error);
    }
  };

  useEffect(() => {
    fetchData();
    getAllClasses()
  }, [offset]);

  const getAllClasses = async () => {
    try {
      const response = await ClassService.getAllClassesWithoutPagination();
      setClasses(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  useEffect(() => {
    if (selectedClassFilter && selectedClassFilter.value) {
      // Pass only the class ID (selectedClassFilter.value)
      getAllSubjects(selectedClassFilter.value);
    } else {
      setSubjects([]);
    }
  }, [selectedClassFilter]);

  const getAllSubjects = async (classId) => {
    try {
      const response = await SubjectService.getAllSubjectsWithoutPagination(classId);
      setSubjects(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      setOffset(0);
      if (
        searchQuery != null ||
        selectedClassFilter != null ||
        selectedMedium != null ||
        selectedSubjectFilter != null ||
        selectedStatusFilter != null
      ) {
        fetchData();
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [searchQuery, selectedClassFilter, selectedMedium, selectedSubjectFilter, selectedStatusFilter]);

  useEffect(() => {
    const fetchUserDataByDate = () => {
      if (startDate || endDate) {
        fetchData(startDate, endDate);
      }
    };

    const timeoutId = setTimeout(fetchUserDataByDate, 500); // Debounce the request

    return () => clearTimeout(timeoutId); // Clear timeout if date changes again quickly
  }, [startDate, endDate]);

  // const removeTimeFromDate = (dateString) => {
  //   if (!dateString) return "";
  //   const dateObject = new Date(dateString);
  //   // Ensure the date is parsed as UTC
  //   const utcYear = dateObject.getUTCFullYear();
  //   const utcMonth = dateObject.toLocaleString("default", {
  //     month: "long",
  //     timeZone: "UTC",
  //   });
  //   const utcDay = dateObject.getUTCDate();
  //   return `${utcDay} ${utcMonth} , ${utcYear}`;
  // };

  const exportToExcel = (data, fileName) => {
    if (!data || data.length === 0) {
      toast.info("No data to export");
      return;
    }

    // Create a worksheet from data
    const ws = XLSX.utils.json_to_sheet(data);

    // Define the grand total row
    // const grandTotalRow = [
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "Grand Total",
    // ];

    // Add grand total row to the end of the sheet
    // XLSX.utils.sheet_add_aoa(ws, [grandTotalRow], { origin: -1 });

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Write the workbook to file
    XLSX.writeFile(wb, fileName);
  };

  const handleExportClick = () => {
    const name = user.name || "";
    const fileName = `${name} Student Data Report.xlsx`;
    exportToExcel(data, fileName);
  };


  // Handle the change event and store the selected value
  const handleDropdownChange = (selectedOption) => {
    setSelectedStatusFilter(selectedOption?.value || ""); // Set selected filter
    setOffset(0); // Reset offset
  };
  
  // Ensure `selectedOption` is derived correctly:
  const selectedOption =
    [{ value: "", label: "All" }, ...statuslist ?? []].find(
      (option) => option.value === selectedStatusFilter
    ) || null
    
  const handleMediumChange = (selectedmedium) => {
    setSelectedMedium(selectedmedium?.value || ""); // Reset to "" if no option selected
    setOffset(0);
  };
  
  // Ensure `selectedOption` is derived correctly:
  const selectedmedium =
    [{ value: "", label: "All" }, ...mediumList ?? []].find(
      (option) => option.value === selectedMedium
    ) || null

  
  const getStatusColor = (status) => {
    const statusColor = {
      approved: "#00A944",
      rejected: "#FF3535",
      edited: "#14489f",
    }
    return statusColor[status] || null
  }

  const deleteSingleUser = async (id) => {
    try {
      await ReviewerService.deleteReviewerQuestionList([id]);
      toast.success("User Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const deleteMultipleuser = async () => {
    try {
      if (data?.findIndex((item) => item.isChecked) != -1) {
        var itemsToDelete = [];
        data.map((item) => {
          if (item.isChecked) {
            itemsToDelete.push(item.id);
          }
        });
      }
      await ReviewerService.deleteReviewerQuestionList(itemsToDelete);
      toast.success("Question Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };


  const cleanQuestionText = (text) => {
    return text.replace(/&nbsp;/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  };


  const customParser = (node) => {
    if (node.name === "oembed") {
      const url = node.attribs.url;
      let videoId;
      // Handle both normal YouTube URLs (youtube.com) and short URLs (youtu.be)
      if (url.includes("youtube.com")) {
        videoId = new URL(url).searchParams.get("v");  // Extract the video ID from the "v" parameter
      } else if (url.includes("youtu.be")) {
        videoId = url.split("/").pop().split("?")[0];  // Extract the ID after the last "/"
      }
      if (videoId) {
        return (
          <iframe
            width="560"
            height="315"
            src={`https://www.youtube.com/embed/${videoId}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="YouTube video"
          />
        );
      } else {
        return <p className='text-danger'>Invalid YouTube URL</p>;
      }
    }
  };


  const getAlphabetLabel = (index) => {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    return letters[index] || "";
  };

  const handleToggleSolution = (index) => {
    // Toggle solution visibility
    setOpenIndex(openIndex === index ? null : index);
  };



  const handleClassChange = (e) => {
    const selectedOption = e ? { value: e.value, label: e.label } : { value: "", label: "Class" };
    
    // Reset other filters
    setSelectedSubjectFilter("");
    setResetSubject(true);
    setResetStatus(true);
    setResetMedium(true);
    setSelectedStatusFilter(null); 
    setSelectedMedium(null);
    
    // Set only the class ID (value)
    setSelectedClassFilter({ value: selectedOption.value, label: selectedOption.label });
    setOffset(0); // Reset offset
  };


  const handleSubjectChange = (e) => {
    const selectedOption = e ? { value: e.value, label: e.label } : { value: "", label: "Subject" };
    
    // Reset other filters

    setSelectedSubjectFilter(selectedOption);
    setOffset(0)

  };
  return (
    <div>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        {
          details?.id ? (
            <h1 className="black fs-18 fw-600 mb-0 text-uppercase">
              {" "}
              View Question
            </h1>
          ) :
            <h1 className="black fs-18 fw-600 mb-0 text-uppercase">
              {" "}
              History
            </h1>
        }

        <div className="d-flex">
          <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0">
            {" "}
            History
          </h4>
        </div>
      </div>
      {details?.id ? (
        <div className="table_container">
          <section className='fs-16 fw-600 my-4'>
            <div className="my-4 border-question pb-4">
              {/* <div className="fs-16 fw-600 mb-3">
          {details.heading} <span style={{ color: details.markColor }}>{details.marks}</span>
        </div> */}

              <div className="fs-16 fw-600 mb-3 d-flex justify-content-start text-center gap-1">
                {/* Question 1 */}
                Question 1
              </div>

              {/* Check if the question is Comprehensive or Poem */}
              {details.type_of_question === 'Comprehensive' || details.type_of_question === 'Poem' ? (
                <div>
                  <div className='fs-14 fw-600 mb-2 pt-2 black border-question-top'>Read Carefully</div>
                  <div className="blog-data-html" style={{ contain: "content", width: '90%' }}>
                    {cleanQuestionText(details.question) && parse(cleanQuestionText(details.question), { replace: customParser })}
                  </div>

                  {/* Render Sub-Questions if Available */}
                  {details.subQuestions && details.subQuestions.length > 0 &&
                    details.subQuestions.map((subQ, subIndex) => {

                      return (
                        <div key={subIndex} className='my-4'>
                          <div className="d-flex justify-content-between">
                            <div className="d-flex gap-2 align-items-center">
                              <div className="fs-16 fw-600 text-dark d-flex align-items-center gap-2">
                                <div style={{ marginBottom: '7px' }}>{subIndex + 1}</div>
                                <div className="w-100 blog-data-html mt-2" style={{ contain: "content" }}>
                                  {cleanQuestionText(subQ.question) && parse(cleanQuestionText(subQ.question), { replace: customParser })}
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* List options for each sub-question */}
                          <ol className="list-group mt-4">
                            {subQ.options.map((option, optIndex) => {
                              const isUserSelected = subQ.selectedOption === optIndex;
                              const isCorrectOption = subQ.correctOption === optIndex;

                              return (
                                <li key={optIndex} className="list-group-item d-flex gap-2 justify-content-between align-items-start border-0 py-0"
                                  style={{
                                    color: isCorrectOption ? 'green' : (isUserSelected && !isCorrectOption) ? 'red' : 'inherit',
                                  }}>
                                  <div className="ms-2 me-auto form-check d-flex align-items-center p-0">
                                    <div className="checkmarks"
                                      style={{
                                        border: isCorrectOption ? 'none' : (isUserSelected && !isCorrectOption ? 'red' : '1px solid #ccc'),
                                        backgroundColor: isCorrectOption ? 'green' : (isUserSelected && !isCorrectOption ? 'red' : 'white'),
                                        marginBottom: "16px"
                                      }}
                                    >
                                      {isUserSelected && !isCorrectOption ? <HiX style={{ fontSize: '16px' }} /> : (isCorrectOption ? <FaCheck style={{ fontSize: '15px' }} /> : '')}
                                    </div>
                                    <label className="form-check-label fs-16 fw-500 px-2">
                                      <div className="d-flex gap-2">
                                        <span>{getAlphabetLabel(optIndex)}. </span> <span>{cleanQuestionText(option) && parse(cleanQuestionText(option), { replace: customParser })}</span>
                                        <div className="text-end">
                                          {isCorrectOption && !isUserSelected && (
                                            <span className="fs-14 ms-3 fw-600" style={{ fontStyle: 'italic' }}>Correct Answer</span>
                                          )}
                                        </div>
                                      </div>
                                    </label>
                                  </div>
                                </li>
                              );
                            })}
                          </ol>
                          {/* Solution toggle for sub-question */}
                          {subQ.solution && (
                            <div className="d-flex gap-2 align-items-center mt-2">
                              <div className='d-flex gap-1 align-items-center cursor-pointer' onClick={() => handleToggleSolution(`${subIndex}`)} >
                                <div>
                                  <h3 className="fs-16 fw-500 mb-0 orangeAsscent" style={{ textDecoration: 'underline' }}> {openIndex === subIndex ? 'Solution' : 'Solution'}</h3>
                                </div>
                              </div>
                            </div>
                          )}
                          {openIndex === `${subIndex}` && (
                            <div className="mt-3" style={{ lineHeight: '24px' }}>
                              <div className="fs-16 fw-600">
                                <div className="w-100 blog-data-html mt-2" style={{ contain: "content" }}>
                                  {cleanQuestionText(subQ.solution) && parse(cleanQuestionText(subQ.solution), { replace: customParser })}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
              ) : (
                <div>
                  <div className="d-flex justify-content-between">
                    <div className="blog-data-html" style={{ contain: "content", width: '90%' }}>
                      {cleanQuestionText(details.question) && parse(cleanQuestionText(details.question), { replace: customParser })}
                    </div>
                  </div>

                  <ol className="list-group my-4">
                    {details.options.map((option, optIndex) => {
                      const isUserSelected = details.selectedOption === optIndex;
                      const isCorrectOption = details.correctOption === optIndex;

                      return (
                        <li key={optIndex} className="list-group-item d-flex gap-2 justify-content-between align-items-start border-0 py-0"
                          style={{
                            color: isCorrectOption ? 'green' : (isUserSelected && !isCorrectOption) ? 'red' : 'inherit',
                          }}>
                          <div className="ms-2 me-auto form-check d-flex align-items-center p-0">
                            <div className="checkmarks"
                              style={{
                                border: isCorrectOption ? 'none' : (isUserSelected && !isCorrectOption ? 'red' : '1px solid #ccc'),
                                backgroundColor: isCorrectOption ? 'green' : (isUserSelected && !isCorrectOption ? 'red' : 'white'),
                                marginBottom: "16px"
                              }}
                            >
                              {isUserSelected && !isCorrectOption ? <HiX style={{ fontSize: '16px' }} /> : (isCorrectOption ? <FaCheck style={{ fontSize: '15px' }} /> : '')}
                            </div>
                            <label className="form-check-label fs-16 fw-500 px-2">
                              <div className="d-flex gap-2 fw-400">
                                <span >{getAlphabetLabel(optIndex)}. </span> <span><p>{cleanQuestionText(option) && parse(cleanQuestionText(option), { replace: customParser })}</p></span>
                                <div>
                                  {isCorrectOption && !isUserSelected && (
                                    <span className="fs-14 ms-3 fw-600" style={{ fontStyle: 'italic' }}>Correct Answer</span>
                                  )}

                                </div>
                              </div>
                            </label>
                          </div>
                        </li>
                      );
                    })}
                  </ol>
                  {details.solution && details.type_of_question === 'General' && (
                    <div className="d-flex gap-2 align-items-center mt-2">
                      <div
                        className='d-flex gap-1 align-items-center cursor-pointer'
                        onClick={() => handleToggleSolution('General')}
                      >
                        <div>
                          <h3 className="fs-16 fw-500 mb-0 orangeAsscent" style={{ textDecoration: 'underline' }}>
                            {openIndex === 'General' ? 'Solution' : 'Solution'}
                          </h3>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Display the solution if the type matches and the toggle is open */}
                  {details.type_of_question === 'General' && openIndex === 'General' && (
                    <div className="mt-3" style={{ lineHeight: '24px' }}>
                      <div className="fs-16 fw-600">
                        <div className="w-100 blog-data-html mt-2" style={{ contain: "content" }}>
                          {cleanQuestionText(details.solution) && parse(cleanQuestionText(details.solution), { replace: customParser })}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </section>
          <div className="d-flex justify-content-start">
            <div
              className="blue cursor-pointer mt-3 fw-500 fs-14"
              onClick={() => {
                setDetails(null);
              }}
            >
              {" "}
              <Image src={SvgImages.left_arrow} className="blue mx-3" />
              Back
            </div>
          </div>
        </div>
      ) : (
        <div className="table_container" style={{ display: "block" }}>
          {/* <h1 className="black fs-18 fw-600 mb-0">Registration Page Listing</h1> */}

          <div className="table_title">
            <div className="table_headings ">
              <h1 className="black fs-18 fw-600 mb-0">
                <div
                  className="table_delete_icon"
                  style={{
                    opacity:
                      data?.findIndex((item) => item.isChecked) == -1 ? 0.3 : 1,
                    pointerEvents:
                      data?.findIndex((item) => item.isChecked) === -1
                        ? "none"
                        : "auto",
                  }}
                  onClick={() => {
                    const reportsPrivilege = user?.setPrivileges?.find(
                      (priv) => priv.parameter === "Reviewer"
                    );
                    if (!reportsPrivilege?.delete) {
                      // If the user does not have delete permission, show a toast warning
                      toast.warning(
                        "You don't have permission to delete history."
                      );
                      return;
                    }

                    if (!(data.findIndex((item) => item.isChecked) == -1)) {
                      setIsMultipleDelete(true);
                      setShowDeleteModal(true);
                    }
                  }}
                >
                  <Image src={SvgImages.deleteIcon} alt="Delete Icon" />
                </div>
              </h1>
            </div>
          </div>

          <div className=" row table_title align-items-center responsivetablepackagetwo">
            <div className="col-lg-6 col-md-12 col-xl-4 gap-2 col-12 pe-0 d-flex  align-items-center sectionPayouts responsivedatepickerstyle  datepickerstyle">
              <div className="">Date:</div>
              <div className="col-xl-5 col-lg-6">
                <DatePicker
                  selected={startDate}
                  onChange={handleStartDateChange}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  dateFormat="yyyy-MM-dd"
                  isClearable
                  placeholderText="From"
                  maxDate={new Date()}
                  customInput={<CustomDateInput />}
                />
              </div>
              <div className="col-xl-5 col-lg-6">
                <DatePicker
                  selected={endDate}
                  onChange={handleEndDateChange}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  dateFormat="yyyy-MM-dd"
                  isClearable
                  placeholderText="To"
                  minDate={startDate}
                  maxDate={new Date()}
                  customInput={<CustomDateInputTo />}
                />
              </div>
            </div>
            <div className="col-xl-6 my-2 col-lg-12 col-md-12 gap-2 Responsivesearchbars  align-items-center d-flex">
              <div className="col-md-8 col-lg-3 col-sm-12">
                <CustomDropDown
                  placeholder="Class"
                  name="class"
                  id="class"
                  Dropdownclass="marginsection"
                  labelClass="commissionsection"
                  onChange={handleClassChange}
                  options={[
                    { value: "", label: "All" },
                    ...classes.map((e) => ({ value: e._id, label: e.class_name }))
                  ]}
                  value={selectedClassFilter}  
                  
                />
              </div>
              <div className="col-md-8 col-lg-3 col-sm-12">
                <CustomDropDown
                  placeholder="Medium"
                  name="medium"
                  id="medium"
                  Dropdownclass="marginsection"
                  labelClass="commissionsection"
                  resetValue={resetmedium}
                  setResetValue={setResetMedium}
                  value={selectedmedium} 
                  options={
                    [{ value: "", label: "All" }, ...mediumList ?? []]
                  }
                  onChange={handleMediumChange}
                />
              </div>

              <div className=" col-md-8 col-lg-3 col-sm-12 ">
                <CustomDropDown
                  placeholder="Subject"
                  name="subject"
                  id="subject"
                  Dropdownclass="marginsection"
                  labelClass="commissionsection"
                  resetValue={resetSubject}
                  setResetValue={setResetSubject}
                  onChange={handleSubjectChange}
                  value={selectedSubjectFilter}  
                  options={
                    [{ value: "", label: "All" }, ...subjects.map((e) => { return { value: e._id, label: e.subject_name } }) ?? []]
                  }
              
                />
              </div>

              <div className="col-md-8 col-lg-3 col-sm-12">
                <CustomDropDown
                  placeholder="Status"
                  inputType={InputType.text}
                  labelClass="commissionsection"
                  Dropdownclass="marginsection"
                  resetValue={resetstatus}
                  setResetValue={setResetStatus}
                  options={
                    [{ value: "", label: "All" }, ...statuslist ?? []]
                  }
                  value={selectedOption}
                  onChange={handleDropdownChange}
                />
              </div>
            </div>

            <div className="col-md-12  col-lg-12 col-xl-2  col-12 d-flex align-items-center justify-content-end respoexportbtn ">
              <ButtonWithIcon
                text={"Export"}
                icon={PngImages.xlspic}
                onClick={handleExportClick}
              />
            </div>
          </div>

          <div style={{ overflowX: "auto" }}>
            <table
              className="table mb-0 "
              id="dtHorizontalExample"
              cellSpacing="0"
              width="100%"
            >
              <thead>
                <tr className="table_heading">
                  <th scope="col" style={{ width: "5%" }}>
                    <label className="d-flex align-items-center justify-content-center">
                      <input
                        className="cursor-pointer"
                        type="checkbox"
                        style={{ height: "16px", aspectRatio: 1 }}
                        checked={
                          data?.length > 0 &&
                          data?.findIndex((item) => !item.isChecked) == -1
                        }
                        onChange={(value) => {
                          var updatedData = data;
                          updatedData.map((element) => {
                            element.isChecked = value.target.checked;
                          });
                          setData([...updatedData]);
                        }}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </th>
                  <th scope="col" style={{ width: "5%" }}>
                    Sr No.
                  </th>
                  <th scope="col" style={{ width: "5%" }}>
                    Date
                  </th>
                  <th scope="col" style={{ width: "5%" }}>
                    Class
                  </th>
                  <th scope="col" style={{ width: "10%" }}>
                    Medium
                  </th>
                  <th scope="col" style={{ width: "10%" }}>
                    Subject
                  </th>
                  <th scope="col" style={{ width: "10%" }}>
                    Question Type
                  </th>
                  <th scope="col" style={{ width: "20%" }}>
                    Questions{" "}
                  </th>
                  <th scope="col" style={{ width: "20%" }}>
                    Updated by{" "}
                  </th>
                  <th scope="col" style={{ width: "5%" }}>
                    Status
                  </th>
                  <th scope="col" style={{ width: "5%" }}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="bg_light">
                {data?.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <label className="d-flex align-items-center justify-content-center">
                        <input
                          className="cursor-pointer"
                          type="checkbox"
                          checked={item.isChecked || false}
                          style={{ height: "16px", aspectRatio: 1 }}
                          onChange={(value) => {
                            var updatedData = data;
                            updatedData[index].isChecked = value.target.checked;
                            setData([...updatedData]);
                          }}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                    <td>{limit * offset + (index + 1)}</td>
                    <td className="text-capitalize">
                      {item?.date}
                    </td>
                    <td>
                      {/* {removeTimeFromDate(item.registrationDate)} */}
                      {item?.class_name}
                    </td>
                    <td>{item?.medium}</td>
                    <td>{item?.subject_name}</td>
                    <td>{item?.type_of_question}</td>
                    <td><h2 className="threeLineText fs-14 fs-500 mb-0 w-100" title={item.question.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ')} >{item.question.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ')}</h2></td>
                    <td>{item?.updatedBy}</td>                    
                    <td className="text-capitalize" style={{ color: getStatusColor(item?.status) }}>
                      {item?.status}
                    </td>
                    <td>
                      <td>
                        <a
                          className="cursor-pointer"
                          style={{ textDecoration: "underline" }}
                          onClick={() => {
                            setDetails(item);
                          }}
                        >
                          View
                        </a>
                      </td>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {generatePaginationFooter(availableDataCount, limit, offset, setOffset)}
        </div>
      )}
      <ConfirmationModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        text={
          isMultipleDelete
            ? "Are you sure want to delete selected Question?"
            : "Are you sure want to delete Question?"
        }
        icon={SvgImages.deleteIcon} // Specify the path to your delete icon
        rightClickAction={() => {
          isMultipleDelete ? deleteMultipleuser() : deleteSingleUser(deleteId);
        }}
        theme={ConfirmationModalTheme.error}
      />
    </div>
  );
};

export default ReviewerHistory;
